module.exports = __webpack_public_path__ + "static/media/team_8.87766c66.png";